import { IconType } from "@shared/enums/icon-type.enum";
import { ColsWithBreakpoint } from '@shared/components/grid/col.component';

export class LabeledInfoItem {
    constructor(
        public label: string,
        public value: any,
        public cols?: ColsWithBreakpoint,
        public suffix?: string,
        public iconType?: IconType,
        public icon?: string,
        public key?: string,
    ){}
}
